import { render, staticRenderFns } from "./InputDialogVertical.vue?vue&type=template&id=183e3bb1&scoped=true&lang=pug"
import script from "./InputDialogVertical.vue?vue&type=script&lang=ts"
export * from "./InputDialogVertical.vue?vue&type=script&lang=ts"
import style0 from "./InputDialogVertical.vue?vue&type=style&index=0&id=183e3bb1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183e3bb1",
  null
  
)

export default component.exports